import * as React from 'react';
import { DropDownList, DropDownListChangeEvent, ListItemProps } from '@progress/kendo-react-dropdowns';
import { fetchApi } from '../services/api';

type Props = {
    callbackFromParent: (data: InvoiceSearchResult) => void;
    className?: string;
    style?: {};
    accountId: number;
    value?: number;
};

type State = {
    defaultValue: InvoiceSearchResult | null;
    invoiceResults: InvoiceSearchResult[];
}

export interface InvoiceSearchResult {
    InvoiceID: number;
    InvoiceNumber: number;
    Amount: number;
}

export default class InvoiceDropDown extends React.Component<Props, State> {
    public componentDidMount() {
        this.getInvoices();
    }

    public componentDidUpdate(prevProps: any) {
        if (this.props.value !== prevProps.value) {
            this.getInvoices();
        }
    }

    constructor(props: Props) {
        super(props);

        this.state = {
            defaultValue: null,
            invoiceResults: [],
        };

        this.getInvoices = this.getInvoices.bind(this);
    };

    onChange = (event: DropDownListChangeEvent) => {
        this.props.callbackFromParent(event.target.value);
    }

    itemRender = (li: any, itemProps: ListItemProps) => {
        const itemChildren = <span style={{ fontSize: "14px", fontFamily: "Arial, Helvetica, sans-serif", whiteSpace: "nowrap", overflow: "hidden" }}>{itemProps.dataItem.InvoiceNumber} - {itemProps.dataItem.BillingPeriodName}</span>;
        return React.cloneElement(li, li.props, itemChildren);
    }

    private getInvoices() {
        const data = {
            AccountId: this.props.accountId,
            FacilityId: parseInt(localStorage.getItem("FACILITY_ID") || "0") || undefined
        };

        fetchApi('api/Account/Invoices', data, 'POST')
            .then((data: InvoiceSearchResult[]) => {
                this.setState({
                    invoiceResults: data
                });
            });
    }

    public render() {
        return (
            <DropDownList
                defaultItem={{ InvoiceNumber: 'Invoice Number', InvoiceID: -1 }}
                defaultValue={this.state.invoiceResults.find(x => x.InvoiceID == this.props.value)}
                data={this.state.invoiceResults}
                itemRender={this.itemRender}
                onChange={this.onChange}
                style={this.props.style}
                className={this.props.className}
                textField="InvoiceNumber"
            />
        );
    }
}
